<template>
  <div>
    <p>This is an example SFC</p>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>

</style>
